export default __webpack_public_path__ + "static/media/_dkg_neuroonko_rgb.2e008c1d.svg";